export default __webpack_public_path__ + "static/media/sh_7.02364f29.png";